/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");
var Defaults = require("json-schema-defaults");
var xtend = require("xtend");
var Promise = require("promise");

var par = require("par");
var dotty = require("dotty");
var FormFileUtils = require("../../utils/FormFileUtil");

const { getVersion, NewCallingVersion } = require("../../utils/GetVersion");

const {
	formatFile,
	findFiles,
} = FormFileUtils;

module.exports = Model({
	name: "activeworkflowaction",
	init: init,
	listeners: listeners,
	triggers: triggers,
	submit: submit,

	updateAction: updateAction,
	uploadFiles: uploadFiles,
	getAction: getAction,

	_actions: [],
	_availability: {},
	_workflowExternals: {},
	_managedUsers: [],
	_groupSettings: {},
	_people: {}
});

function init(){
	this.push(false);
}

function listeners() {
	return {
		"workflowactions:updated": handle_action_update,
		"availability:updated": handle_availability,
		"workflowexternals:updated": handle_workflowExternals,
		"managedusers:updated": handleManagedUsersUpdated,
		"groupsettings:updated": handleGroupSettingsUpdated,
		"people:updated": handlePeopleUpdated
	};
}

function triggers(){
	return {
		view: view,
		hide: hide,
		submit: submit,
		call: call,
		form: form,
		resource: resource,
		"manager:resource": manageResource
	};
}

function view(data){
	var action = data.action;
	this._viewing = action;
	this.updateAction();
	this.dispatch("viewing");

	const actionData = this.getAction(action);
	if(!actionData) return;

	const actionOwner = actionData?.ongoingWorkflow?.owner?._id;
	const found = this._managedUsers.find(user => {
		return user._id === actionOwner;
	});

	if(found){
		this.emit("managedaccount:trigger:load", {
			who: actionOwner
		});
	}

	this.emit("usermetrics:trigger:track", "view own pathway action", {
		action: action
	});
}

function hide(){
	this.push(false);
	this.dispatch("finish");
	this.emit("usermetrics:trigger:track", "hide pathway action");
}

function uploadFile(data){
	var file = data.data;
	return this.api.workflow.actions.upload(file)
		.then(function(uploaded){
			return {
				key: data.key,
				file: uploaded
			};
		});
}

function uploadFiles(files, data){
	if(!files.length) return Promise.resolve(data);
	return Promise.all(files.map(uploadFile.bind(this))).then(function(uploaded){
		uploaded.forEach(function(upload){
			dotty.put(data, upload.key, formatFile(upload.file));
		});
		return data;
	});
}

function submit(result){
	this.emit("save:trigger:start");
	var action = this.data._id;
	// TODO: Loading and error handling

	var currentAction = this.data.action;
	var actionForm = this.data.ongoingWorkflow.workflow.actions[currentAction] || {};
	var formProperties = actionForm.properties;


	var workflowId = this.data.ongoingWorkflow._id;
	var externals = this._workflowExternals[workflowId] || {};
	let mergedFormProperties = shallowMergeExternalsWithSchema(formProperties, externals);
	var files = findFiles(mergedFormProperties, result);
	var api = this.api.workflow.actions.submit;

	this.emit("usermetrics:trigger:track", "submit own pathway action", {
		action: action
	});


	return this.uploadFiles(files, result)
		.then(par(api, action))
		.then(finishSubmit.bind(this))
		.catch(handle_error.bind(this));
}

function finishSubmit(){
	this.emit("save:trigger:finish");
}

function shallowMergeExternalsWithSchema(schema, externals){
	let retObject = {};
	let keys = Object.keys(schema);

	keys.forEach((key)=>{
		var property = schema[key];
		if(property.inputType === "externalform"){
			var externalKeyStr = property.external || "";
			var externalKey = externalKeyStr.split(":")[1];
			var externalSchema = externals[externalKey];
			retObject[key] = externalSchema;

		} else {
			retObject[key] = property;
		}
	});

	return retObject;
}

function handle_action_update(actions) {
	this._actions = actions;

	var existing = this.data;

	if(!existing) return;

	var stillExists = actions.some(function(action){
		return action._id === existing._id;
	});

	if(!stillExists){
		this._viewing = null;
		this.push(false);
		this.dispatch("finish");
		this.emit("pausescreen:trigger:pause");
	}

	if(this._viewing)
		this.updateAction();
}

function call(data){
	var actor = data.actor;
	if(!this.data) return;
	var available = this._availability;
	var actorIds = this.data.ongoingWorkflow.actors.filter(function(actorData){
		return (actorData.actor === actor) && available[actorData.who._id];
	});

	if(!actorIds.length) return;

	var randomActor = getRandomInt(0, (actorIds.length - 1));
	var who = actorIds[randomActor].who._id;

	const isCallingEnabled = this._groupSettings?.isNewCallingEnabled;
	const people = this._people;
	const whoData = people[who];

	let callEvent = "calling:trigger:call";

	const version = getVersion(whoData.versionInfo || {});
	const isNewCallingSupported = version && version.majorVersion >= NewCallingVersion;
	if (isNewCallingSupported && isCallingEnabled){
		callEvent = "meetings:workflow:start";
	}

	this.emit(callEvent, {
		who: who,
		voiceOnly: data.voiceOnly
	});

	this.emit("usermetrics:trigger:track", "call from pathway action", {
		who: who
	});
}

// Used to view a type of form submission
function form(data) {
	var externalName = data.form;
	var externals = this.data.ongoingWorkflow.externals || {};
	var externalId = externals[externalName];
	if (!externalId) {
		this.emit("usermetrics:trigger:track", "attempt to view form from pathway action, but it does not exist", {
			pathway: this.data.ongoingWorkflow._id,
		});
		return this.emit("toast:trigger:show", {
			content: "Form not specified",
			style: "error"
		});
	}

	this.emit("usermetrics:trigger:track", "view form from pathway action", {
		pathway: this.data.ongoingWorkflow._id,
		form: externalId,
	});

	this.emit("ownformsubmissions:trigger:search", {
		form: externalId,
		action: this._viewing,
	});

	this._viewing = false;
	this.extend({
		collapsed: true
	});
}

function handle_availability(availability) {
	this._availability = availability;
}

function handle_workflowExternals(workflowExternals) {
	this._workflowExternals = workflowExternals;
}


function resource(data){
	var externalName = data.resource;
	var externals = this.data.ongoingWorkflow.externals || {};
	var externalId = externals[externalName];

	if(!externalId) {
		this.emit("usermetrics:trigger:track", "attempt to view resource from pathway action, but it does not exist", {
			pathway: this.data.ongoingWorkflow._id,
		});
		return this.emit("toast:trigger:show", {
			content: "Resource not specified",
			style: "error"
		});
	}

	this.emit("usermetrics:trigger:track", "view resource from pathway action", {
		pathway: this.data.ongoingWorkflow._id,
		resource: externalId,
	});
	this.emit("ownresources:trigger:search", {
		id: externalId,
		action: this._viewing
	});

	this._viewing = false;
	this.extend({
		collapsed: true
	});
}

function handle_error(e){
	this.emit("save:trigger:finish");
	console.error(e);
}

function getRandomInt(min, max) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

async function updateAction() {
	var action = this._viewing;

	var actionData = this._actions.reduce(function (result, existing) {
		if (existing._id === action) return existing;
		return result;
	}, null);

	if (!actionData) return;

	const { persistStorage } = await this.api.persiststorage.getData(action);

	var actionLabel = actionData.action;
	var actionSchema = actionData.ongoingWorkflow.workflow.actions[actionLabel];

	var autoDefaults = Defaults(actionSchema);
	var existingDefaults = actionData.defaults || {};
	var defaultData = existingDefaults;

	if (persistStorage?.length && persistStorage[0]?.data) {
		defaultData = { ...existingDefaults, ...persistStorage[0].data };
	}

	var finalDefaults = xtend(autoDefaults, defaultData);

	var finalAction = xtend(actionData, {
		defaults: finalDefaults,
	});

	this.push(finalAction);
}

function manageResource(data){
	const externalName = data.resource;
	const externals = this.data.ongoingWorkflow.externals || {};
	const externalId = externals[externalName];

	if(!externalId) {
		this.emit("usermetrics:trigger:track", "attempt to view managed resource from pathway action, but it does not exist", {
			pathway: this.data.ongoingWorkflow._id,
		});
		return this.emit("toast:trigger:show", {
			content: "Resource not specified",
			style: "error"
		});
	}

	this.emit("usermetrics:trigger:track", "view managed resource from pathway action", {
		pathway: this.data.ongoingWorkflow._id,
		resource: externalId,
	});
	this.emit("managedresources:trigger:viewresource", {
		id: externalId
	});

	this._viewing = false;
	this.extend({
		collapsed: true
	});
}

function handleManagedUsersUpdated(data){
	this._managedUsers = data;
}

function getAction(actionId){
	return this._actions.find(function (existing) {
		return existing._id === actionId;
	});
}

function handleGroupSettingsUpdated(data){
	this._groupSettings = data;
}

function handlePeopleUpdated(data){
	this._people = data;
}